import { AVAILABLE_APPOINTMENT_DAY_URL } from "../../constants/urls";
import { apiSlice } from "./apiSlice";

export const availableAppointmentDayApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableAppointmentDayByDoctorId: builder.query({
      query: (id) => ({
        url: `${AVAILABLE_APPOINTMENT_DAY_URL}/getbydoctorid/${id}`,
        method: "GET",
      }),
    }),
    addAvailableAppointmentDay: builder.mutation({
      query: (data) => ({
        url: `${AVAILABLE_APPOINTMENT_DAY_URL}`,
        method: "POST",
        body: data,
      }),
    }),
    updateAvailableAppointmentDay: builder.mutation({
      query: (data) => ({
        url: `${AVAILABLE_APPOINTMENT_DAY_URL}`,
        method: "PUT",
        body: data,
      }),
    }),
    removeAppointmentDay: builder.mutation({
      query: (id) => ({
        url: `${AVAILABLE_APPOINTMENT_DAY_URL}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useRemoveAppointmentDayMutation,
  useAddAvailableAppointmentDayMutation,
  useLazyGetAvailableAppointmentDayByDoctorIdQuery,
  useUpdateAvailableAppointmentDayMutation,
} = availableAppointmentDayApiSlice;
